import { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { authorization_code } from "../utils/endpoints";

export default function MoodleAuthorization() {
  const [context, setContext] = useOutletContext();

  useEffect(() => {
    if (context.session) {
      let url = new URL(window.location.href);
      const client_id = url.searchParams.get("client_id");
      const code_challenge = url.searchParams.get("code_challenge");
      const code_challenge_method = url.searchParams.get(
        "code_challenge_method"
      );
      const state = url.searchParams.get("state");

      if (client_id && code_challenge && state && code_challenge_method) {
        (async () => {
          let response = await context.httpRequest(
            "post",
            authorization_code,
            { codeChallenge: code_challenge },
            context.session.token
          );

          if (response.result) {
            const small_session_info = {
              client_id: client_id,
              code_challenge: code_challenge,
              code_challenge_method: code_challenge_method,
              state: state,
              response_data: btoa(
                JSON.stringify({
                  auth_code: response.data,
                })
              ),
            };

            postBackData(
              `${process.env.REACT_APP_MOODLE_BASE_URL}/q8auth/q8_sso.php`,
              small_session_info,
              "get"
            );
          } else context.navigateUrl("/");
        })();
      } else context.navigateUrl("/");
    }
  }, [context.session]);

  const postBackData = (path, params, method = "post") => {
    const form = document.createElement("form");
    form.method = method;
    form.action = path;

    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = key;
        hiddenField.value = params[key];

        form.appendChild(hiddenField);
      }
    }

    document.body.appendChild(form);
    form.submit();
  };

  return <></>;
}
